import React from 'react';
import {Link} from "react-router-dom";

export default class Splash extends React.Component{
	constructor(props){
		super(props);
		this.state={};
	}
	componentWillUnmount(){
		this.props.toChangeShadowToLow();
	}
	render(){
		return(
			<div className='splash'>
				Jester<br/>
				&<br/>
				Niko
				<div className='down'>
					<div className='earth'>
						save the electricity. take care of the Earth
					</div>
					<div
						onClick={this.props.toDelete}
						className='site'>
						visit site
					</div>
				</div>
			</div>
		)
	}
}